import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, Img, Text, Heading } from "./..";
import { API_DOMAIN } from "config";
import ProposalDetails from "../../components/ProposalDetails";
import NotificationCard2 from "../../components/NotificationCard2";

export default function LeftMenuNotificationsDealerDashboard({ currentUser }) {
const [notifications, setNotifications] = useState([]);

  /** 1) מביא את ההתראות מהשרת */


  /* 2) מביא את ההתראות */
  const fetchNotifications = async () => {
    try {
      const { data } = await axios.get(`${API_DOMAIN}/notification/list`, {
        params: { user_id: currentUser.id },
      });
      setNotifications(data);
    } catch (err) {
      console.error("⛔ get notifications:", err);
    }
  };

const markRead = async (id) => {
  try {
await axios.put(
  `${API_DOMAIN}/notification/markReadOne/${id}`,
  { user_id: currentUser.id },
  { headers: { "Content-Type": "application/json" } }
);

  
  } catch (err) {
    console.error("⛔ mark-read:", err);
  }
};

const handleClose = (id) => {
  setNotifications((prev) => prev?.filter((n) => n?.id !== id));
  markRead(id);                 // ← עכשיו גם ב-DB is_read=1
};

  /* 5) טעינה ראשונית + Polling */
  useEffect(() => {
   // debugger
    if (!currentUser?.id) return;        // הגנה אם id עדיין undefined
    fetchNotifications();
    const t = setInterval(fetchNotifications, 60_000);
    return () => clearInterval(t);
  }, [currentUser?.id]);

  return (
    <div
      className="hide-mobile flex w-[16%] flex-col gap-3 rounded-[24px] bg-secondary-primary_white p-6 shadow-xs md:w-full sm:p-4"
      style={{ bottom: "1rem", position: "fixed", left: "1rem", height: "47v", display: 'none' }}
    >
       
                   {/*   <div className="flex gap-3" style={{justifyContent:'right'}}>
                        <Heading size="heading9xl" as="h4" className="!font-heebo text-[25px] font-bold lg:text-[21px]">
                         התראות
                        </Heading>
                        <Img src="/images/bell.svg" alt="Car" className="h-[28px]" />
                      </div>*/}
      {/* כותרת עליונה */}


      {/* פס הפרדה */}
      <div className="h-px bg-blue_gray-100" />

      {/* תוכן ההצעות */}
      <div className="flex flex-col gap-[22px]">
      
    {/*<div className="flex flex-wrap">
{notifications?.map((n) => (
  <div
    key={n?.id}
    className="relative bg-white rounded-[24px] px-6 py-4"
  >
    <NotificationCard2
      notification={n}
      onClose={() => handleClose(n?.id)}
    />
  </div>
))}


          {notifications?.length === 0 && (
            <p className="mx-auto text-gray-500">אין התראות חדשות ✨</p>
          )}
        </div>*/}
    
      </div>
    </div>
  );
}
